import React, { useEffect, useState } from 'react'
import './styles.css'
import CallToAction from '../../atoms/callToAction'
import FixWidthContainer from '../../atoms/fixWidthContainer'
import logo from '../../../assets/img/logo.png'

export default function Header() {
  const [isMobile, setIsMobile] = useState(false)
  const [showHeader, setShowHeader] = useState(false)

  useEffect(() => {
    // Detect if the viewport is mobile
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }

    // Scroll listener to show/hide header
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowHeader(true)
      } else {
        setShowHeader(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header className={`header-container ${showHeader ? 'visible' : 'hidden'}`}>
      <FixWidthContainer
        width="70%"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <img src={logo} alt="logo" height={isMobile ? 50 : 70} />
        <CallToAction
          marginRight={0}
          gap={isMobile ? 0 : 16}
          width={isMobile ? 140 : 250}
        >
          Agendar Consulta
        </CallToAction>
      </FixWidthContainer>
      {/* <div className="social-media-container">
        <img src={instagram} alt="instagram" height={44} width={40} />
      </div> */}
    </header>
  )
}
